<template>
  <small :style="`color: ${calculatedColor}`" class="small">
    <slot></slot>
  </small>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: false,
    },
  },
  data() {
    const getColor = () => {
      const isCurrentColor = this.color === 'currentcolor';
      const isGray = this.color === 'gray';

      if (isCurrentColor) return 'currentcolor';
      if (isGray) return 'var(--gray-800)';

      return 'var(--gray-900)';
    };

    return {
      calculatedColor: getColor(),
    };
  },
};
</script>

<style scoped>
.small {
  display: inline;
  margin-top: 0;
  margin-bottom: 0;

  color: var(--gray-800);

  font-size: 14px;
  font-family: var(--font-family-sans);
  font-weight: 400;
  line-height: 20px;
  text-align: left !important; /* NOTE @chris Global leak. */
}

.small b {
  font-weight: 500;
}
</style>
